import { useProperty, useTranslation } from '@eti/providers';
import { PartOfExternalFlights } from '@eti/schema-types';
import { Stack, Text } from '@etg/wings';
import TopicsContentWrapper from '../TopicsContentWrapper';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import FaqSection from '../../common/FaqSection';
import ContactRyanairContent from './ContactRyanairContent';

const AddPassenger = () => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { partOfExternalFlights, faqSectionPerSlug } = useOrderDetails();
  const faqSectionSlug = p('ContactUs.AddPassenger.Faq.Slug');

  if (partOfExternalFlights === PartOfExternalFlights.All) {
    return <ContactRyanairContent faqSectionSlug={faqSectionSlug} />;
  }

  return (
    <TopicsContentWrapper
      chatType="genesys"
      leftColumnContent={
        <Stack spacing={24}>
          <Text asHtml>{t('ContactUs.Subtopic.AddPassenger.Content')}</Text>
          {faqSectionPerSlug?.[faqSectionSlug] && (
            <FaqSection
              headingAs="h5"
              headingLevel={4}
              padding={0}
              section={faqSectionPerSlug[faqSectionSlug]}
            />
          )}
        </Stack>
      }
      snowplowProperty="ADD_PASSENGER"
    />
  );
};

export default AddPassenger;
